/**
 * Factory for CustomerLiveEventRepository.
 * Always returns the v2 implementation (v1 has been removed).
 *
 * Pure TypeScript - no React imports.
 */

import type {CustomerLiveEventRepository} from "../../domain/types";
import {CustomerLiveEventRepositoryV2} from "./repository.v2";

let repositoryInstance: CustomerLiveEventRepository | null = null;

/**
 * Returns the CustomerLiveEventRepository instance.
 * Instance is cached for the lifetime of the app.
 */
export function getCustomerLiveEventRepository(): CustomerLiveEventRepository {
  if (!repositoryInstance) {
    repositoryInstance = new CustomerLiveEventRepositoryV2();
  }
  return repositoryInstance;
}

/**
 * Clears the cached repository instance.
 * Useful for resetting state between tests.
 */
export function clearCustomerLiveEventRepositoryCache(): void {
  repositoryInstance = null;
}
